module.exports = __webpack_public_path__ + "img/unsplash_HuE1cJo-x34.5677677f.png";